export default __webpack_public_path__ + "static/media/logo.943f7f31.png";